import { render, staticRenderFns } from "./DataImportPetoreluPlusForm.vue?vue&type=template&id=366cb024&scoped=true&"
import script from "./DataImportPetoreluPlusForm.vue?vue&type=script&lang=js&"
export * from "./DataImportPetoreluPlusForm.vue?vue&type=script&lang=js&"
import style0 from "./DataImportPetoreluPlusForm.vue?vue&type=style&index=0&id=366cb024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366cb024",
  null
  
)

export default component.exports